/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CustomerSortSpecification } from '../model/customerSortSpecification';
import { GetCustomerQueryResult } from '../model/getCustomerQueryResult';
import { GetCustomersQueryResult } from '../model/getCustomersQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomersService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param filterName 
     * @param filterEmail 
     * @param filterPhoneNumber 
     * @param filterSSN 
     * @param filterCity 
     * @param filterMunicipality 
     * @param filterHasApplication 
     * @param sort 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customersGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterCity?: string, filterMunicipality?: string, filterHasApplication?: boolean, sort?: Array<CustomerSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetCustomersQueryResult>;
    public customersGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterCity?: string, filterMunicipality?: string, filterHasApplication?: boolean, sort?: Array<CustomerSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCustomersQueryResult>>;
    public customersGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterCity?: string, filterMunicipality?: string, filterHasApplication?: boolean, sort?: Array<CustomerSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCustomersQueryResult>>;
    public customersGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterCity?: string, filterMunicipality?: string, filterHasApplication?: boolean, sort?: Array<CustomerSortSpecification>, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterName !== undefined && filterName !== null) {
            queryParameters = queryParameters.set('Filter.Name', <any>filterName);
        }
        if (filterEmail !== undefined && filterEmail !== null) {
            queryParameters = queryParameters.set('Filter.Email', <any>filterEmail);
        }
        if (filterPhoneNumber !== undefined && filterPhoneNumber !== null) {
            queryParameters = queryParameters.set('Filter.PhoneNumber', <any>filterPhoneNumber);
        }
        if (filterSSN !== undefined && filterSSN !== null) {
            queryParameters = queryParameters.set('Filter.SSN', <any>filterSSN);
        }
        if (filterCity !== undefined && filterCity !== null) {
            queryParameters = queryParameters.set('Filter.City', <any>filterCity);
        }
        if (filterMunicipality !== undefined && filterMunicipality !== null) {
            queryParameters = queryParameters.set('Filter.Municipality', <any>filterMunicipality);
        }
        if (filterHasApplication !== undefined && filterHasApplication !== null) {
            queryParameters = queryParameters.set('Filter.HasApplication', <any>filterHasApplication);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('Sort', <any>element);
            })
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetCustomersQueryResult>('get',`${this.basePath}/Customers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customersUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetCustomerQueryResult>;
    public customersUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCustomerQueryResult>>;
    public customersUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCustomerQueryResult>>;
    public customersUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling customersUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetCustomerQueryResult>('get',`${this.basePath}/Customers/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
